/* Amit Pasha — shared form behaviour (every form that renders snippets/form-meta):
   • UTMs + landing page + referrer are captured on the first page of the visit and kept (localStorage, 30 days)
   • hidden fields are filled on submit (page title / URL are already set by Liquid)
   • spam: a filled honeypot or a submit faster than 2.5 s after the page loaded is silently dropped
   • webhook: when set in Theme settings → Forms, the full submission is also POSTed as JSON (text/plain, no CORS preflight)
     to Make / Zapier / n8n; "notify_to" tells the automation where to email it. The form then submits normally. */
(function () {
  'use strict';
  var KEY = 'ap_attr', loadedAt = Date.now();
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];   // the ad click ids are kept with the campaign

  // ---- attribution: keep the latest campaign, the first landing page of the visit
  var attr = {};
  try { attr = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) {}
  if (attr.t && Date.now() - attr.t > 30 * 864e5) attr = {};
  try {
    var qs = new URLSearchParams(location.search), got = false;
    UTM.forEach(function (k) { if (qs.get(k)) got = true; });
    if (got) UTM.forEach(function (k) { attr[k] = qs.get(k) || ''; });
    if (!attr.landing_page) { attr.landing_page = location.href.split('#')[0]; attr.referrer = document.referrer || ''; }
    attr.t = attr.t || Date.now();
    localStorage.setItem(KEY, JSON.stringify(attr));
  } catch (e) {}

  function fill(form) {
    form.querySelectorAll('[data-ap-meta]').forEach(function (el) {
      var k = el.getAttribute('data-ap-meta');
      if (UTM.indexOf(k) > -1 || k === 'landing_page' || k === 'referrer') el.value = attr[k] || '';
      if (k === 'page_url' && !el.value) el.value = location.href.split('#')[0];
      if (k === 'page_title' && !el.value) el.value = document.title;
    });
  }
  function payload(form) {
    var data = {};
    new FormData(form).forEach(function (v, k) {
      if (k === 'form_type' || k === 'utf8' || k === 'return_to' || k === 'contact[website]' || typeof v !== 'string') return;
      var m = k.match(/^(?:contact|customer)\[(.+)\]$/); data[m ? m[1] : k] = v;
    });
    var meta = form.querySelector('[data-ap-meta="form"]');
    data.notify_to = meta ? meta.getAttribute('data-ap-to') || '' : '';
    data.gclid = attr.gclid || ''; data.fbclid = attr.fbclid || '';   // no hidden field for these - straight from the kept attribution
    data.submitted_at = new Date().toISOString();
    return same(data);
  }
  // Tamir 20.10: every form sends the same names, so one Zapier / Make step reads them all -
  // full_name, first_name, last_name, email, phone (with the country code), message; the form's other fields follow
  function same(d) {
    var full = (d.full_name || d.name || [d.first_name, d.last_name].filter(Boolean).join(' ')).trim(), sp = full.indexOf(' ');
    var out = { form: d.form || '', full_name: full, first_name: d.first_name || (sp > 0 ? full.slice(0, sp) : full), last_name: d.last_name || (sp > 0 ? full.slice(sp + 1) : ''), email: d.email || '', phone: phoneOf(d.phone || d.mobile || '', d.phone_country || ''), message: d.body || d.message || '' };
    ['form', 'full_name', 'name', 'first_name', 'last_name', 'email', 'phone', 'mobile', 'body', 'message'].forEach(function (k) { delete d[k]; });
    Object.keys(d).forEach(function (k) { out[k] = d[k]; });
    return out;
  }
  // the phone with its country code, for Israel and abroad (+972 / +1 / +44 ...)
  // Zapier 24.10: the browser's autofill sometimes puts the whole number in the country box ("0502820204502820204" came in) -
  // a country box that is not "+" and 1-4 digits is ignored; a country code typed again inside the number is dropped
  function phoneOf(raw, rawCc) {
    var num = String(raw).replace(/[^\d+]/g, ''), cc = String(rawCc).replace(/\s/g, '');
    if (!/^\+\d{1,4}$/.test(cc)) cc = '';
    if (!num || num.charAt(0) === '+') return num;
    if (num.slice(0, 2) === '00') return '+' + num.slice(2);                   // 00 + country code
    if (!cc && num.charAt(0) === '0') cc = '+972';                              // a local Israeli number (the contact form has no country field)
    if (!cc) return num;
    var d = cc.slice(1);
    if (num.indexOf(d) === 0 && num.length >= d.length + 9) num = num.slice(d.length);   // "972 54..." with +972 chosen
    return cc + num.replace(/^0/, '');
  }
  function send(form) {   // post to the webhook (also used by forms that submit with their own script, e.g. the engagement consultation)
    var meta = form.querySelector('[data-ap-meta="form"]'), hook = meta && meta.getAttribute('data-ap-hook');
    if (!hook) return;
    if (form.__apSent && Date.now() - form.__apSent < 10000) return;   // already sent for this submit (the form's own script or a re-fired submit)
    form.__apSent = Date.now();
    fill(form);
    try { fetch(hook, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload(form)) }); } catch (err) {}
  }
  function isBot(form) { var hp = form.querySelector('[data-ap-hp]'); return !!(hp && hp.value) || Date.now() - loadedAt < 2500; }
  function filled(form) {   // every required field filled - the same check the forms' own validation does
    return [].every.call(form.querySelectorAll('[required]'), function (el) {
      if (el.type === 'checkbox') return el.checked;
      var v = (el.value || '').trim();
      return v !== '' && (el.type !== 'email' || /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v));
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target; if (!form || !form.querySelector || !form.querySelector('[data-ap-meta="form"]')) return;
    if (isBot(form)) {                                                // bot: pretend it worked, send nothing
      e.preventDefault(); e.stopImmediatePropagation();
      var rt = form.querySelector('input[name="return_to"]');
      if (rt && rt.value && rt.value !== 'back') location.href = rt.value; else form.reset();
      return;
    }
    // Shopify's spam check (captcha) stops the submit and posts the form itself afterwards, without a new submit event -
    // so a stopped submit is skipped only when a required field is really missing (the form's own validation)
    if (e.defaultPrevented && !filled(form)) return;
    send(form);
  }, false);

  document.querySelectorAll('form').forEach(function (f) { if (f.querySelector('[data-ap-meta]')) fill(f); });
  window.theme = window.theme || {}; window.theme.forms = { fill: fill, payload: payload, send: send, isBot: isBot, attribution: attr };
})();
